export default __webpack_public_path__ + "static/media/home-category-broma-temporary.f1039026.jpg";